import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={26.795}
      height={46.573}
      viewBox="0 0 26.795 46.573"
      {...props}
    >
      <g data-name="Component 38 \u2013 1">
        <g data-name="light-bulb (6)" fill="#fff">
          <g data-name="Group 327">
            <path
              data-name="Path 7444"
              d="M15.837 2.6a.743.743 0 00-.743-.743h-2.971a.743.743 0 000 1.486h2.971a.743.743 0 00.743-.743z"
            />
            <path
              data-name="Path 7445"
              d="M15.837 4.086a.743.743 0 00-.743-.743h-2.971a.743.743 0 100 1.486h2.971a.743.743 0 00.743-.743z"
            />
            <path
              data-name="Path 7446"
              d="M11.377 5.571v.743h4.457v-.743a.743.743 0 00-.743-.743H12.12a.743.743 0 00-.743.743z"
            />
          </g>
          <g data-name="Group 328">
            <path
              data-name="Path 7447"
              d="M13.609.372a1.486 1.486 0 00-1.486 1.486h2.971A1.486 1.486 0 0013.609.372z"
            />
            <path
              data-name="Path 7448"
              d="M10.637 7.058v.871a1.476 1.476 0 01-.56 1.137 5.571 5.571 0 107.035-.023 1.481 1.481 0 01-.532-1.157v-.828a.745.745 0 00-.743-.743h-4.462a.745.745 0 00-.738.743z"
            />
          </g>
          <g data-name="Group 329">
            <path
              data-name="Path 7449"
              d="M17.345 8.752a1.114 1.114 0 01-.394-.868v-.827a1.114 1.114 0 00-.743-1.046v-.44a1.109 1.109 0 00-.29-.743 1.1 1.1 0 000-1.486 1.1 1.1 0 00-.483-1.8 1.851 1.851 0 00-3.651 0 1.1 1.1 0 00-.487 1.8 1.1 1.1 0 000 1.486 1.109 1.109 0 00-.29.743v.44a1.114 1.114 0 00-.743 1.046v.871a1.107 1.107 0 01-.424.849 5.943 5.943 0 003.763 10.536c.1 0 .195 0 .292-.007a6.011 6.011 0 005.654-5.9 5.909 5.909 0 00-2.204-4.654zm-5.594-3.181a.372.372 0 01.371-.371h2.971a.372.372 0 01.371.371v.371H11.75zm0-1.486a.372.372 0 01.371-.371h2.971a.372.372 0 110 .743h-2.971a.371.371 0 01-.371-.372zM13.608.743a1.116 1.116 0 011.051.743h-2.1a1.117 1.117 0 011.049-.743zm-1.486 1.485h2.971a.372.372 0 110 .743h-2.971a.372.372 0 110-.743zm1.739 16.336a5.2 5.2 0 01-3.55-9.211 1.846 1.846 0 00.7-1.425v-.871a.372.372 0 01.371-.371h4.45a.372.372 0 01.371.371v.828a1.843 1.843 0 00.669 1.446 5.169 5.169 0 011.931 4.072 5.259 5.259 0 01-4.942 5.161z"
            />
            <path data-name="Path 7452" d="M7.682 17.221l-1.286.743z" />
          </g>
        </g>
        <path
          data-name="Line 65"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth={1.5}
          d="M20.898 14.444l5 22"
        />
        <path
          data-name="Line 66"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth={1.5}
          d="M5.898 14.444l-5 22"
        />
        <path
          data-name="right (1)"
          d="M5.156 40.137c.039 3.063 3.706 5.536 8.216 5.531.368 0 .666.2.666.453s-.298.452-.666.452c-5.248 0-9.516-2.873-9.55-6.437l.665-.6zm2.53.281l-2.665-2.413a.806.806 0 00-.533-.181.806.806 0 00-.532.181l-2.667 2.413c-.221.2-.161.484.133.634a.89.89 0 00.933-.091l2.133-1.931 2.132 1.931a.89.89 0 00.933.091c.294-.15.354-.434.133-.634z"
          fill="#fff"
        />
        <path
          data-name="right (1)"
          d="M20.791 40.137c-.041 3.063-3.707 5.536-8.217 5.531-.366 0-.666.205-.666.452s.3.453.666.453c5.248 0 9.515-2.873 9.549-6.437l-.665-.6zm-2.531.281l2.665-2.413a.875.875 0 011.066 0l2.666 2.413c.221.2.161.484-.133.634a.89.89 0 01-.933-.091l-2.133-1.931-2.132 1.931a.89.89 0 01-.933.091c-.294-.15-.354-.434-.133-.634z"
          fill="#fff"
        />
        <text
          data-name={230}
          transform="translate(13.976 36.944)"
          fill="#fff"
          fontSize={10}
          fontFamily="IRANYekanFN-Medium, IRANYekanFN"
          fontWeight={500}
        >
          <tspan x={10} y={0}>
            {"230"}
          </tspan>
        </text>
        <text
          data-name={0}
          transform="translate(18.976 28.944)"
          fill="#fff"
          fontSize={7}
          fontFamily="IRANYekanFN-Thin, IRANYekanFN"
          fontWeight={200}
        >
          <tspan x={-1.723} y={0}>
            {"0"}
          </tspan>
        </text>
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
